import style from './comparing-table.module.scss'
import {
    IComparingDedicatedTeamTable
} from '@components/services/dedicated-teams/dedicated-teams.state';
import template from '@components/services/services.module.scss';


interface IComparingTableProps {
    title: string;
    description: string;
    isActive: string;
    tables: IComparingDedicatedTeamTable[];
}

export const ComparingTable = ({ title, description, isActive, tables }: IComparingTableProps) => {
    return (
        <div className={`${style.comparing__table} ${title === isActive ? style.comparing__table_active : null}`}>
            <div className={`${template.mb40} ${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_c} ${style.comparing__description} ${template.fw400}`}>
                {description}
            </div>
            <div className={`${style.comparing__table_wrapper}`}>
                {
                    tables.map((item: IComparingDedicatedTeamTable, index: number) => {
                        return(
                            <div key={index} className={`${style.comparing__table_column}`}>
                                <div className={`${style.comparing__table_header}`}>{item.title}</div>
                                {
                                    item.text.map((textItem: string, index: number) => {
                                        return (
                                            <div key={index} className={`${style.comparing__table_text}`}>
                                                {textItem}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
